"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tester = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _react2 = require("@jsonforms/react");

var _core = require("@jsonforms/core");

var _materialRenderers = require("@jsonforms/material-renderers");

var _core2 = require("@material-ui/core");

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var renderer = function renderer(layout) {
  return /*#__PURE__*/_react["default"].createElement(_materialRenderers.MaterialLayoutRenderer, layout);
};

var MyGroupRenderer = function MyGroupRenderer(props) {
  var uischema = props.uischema,
      schema = props.schema,
      path = props.path,
      visible = props.visible,
      renderers = props.renderers;
  var layoutProps = {
    elements: uischema.elements,
    schema: schema,
    path: path,
    direction: 'column',
    visible: visible,
    uischema: uischema,
    renderers: renderers
  };
  return /*#__PURE__*/_react["default"].createElement(_core2.Hidden, {
    xsUp: !visible
  }, /*#__PURE__*/_react["default"].createElement(_core2.Accordion, null, /*#__PURE__*/_react["default"].createElement(_core2.AccordionSummary, {
    expandIcon: /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null)
  }, /*#__PURE__*/_react["default"].createElement(_core2.Typography, null, uischema.label)), /*#__PURE__*/_react["default"].createElement(_core2.AccordionDetails, null, /*#__PURE__*/_react["default"].createElement(_materialRenderers.MaterialLayoutRenderer, layoutProps))));
};

var tester = (0, _core.rankWith)(1000, (0, _core.and)(_core.isGroup, function (uischema) {
  return uischema.hasOwnProperty('acl');
}));
exports.tester = tester;

var _default = (0, _react2.withJsonFormsLayoutProps)(MyGroupRenderer);

exports["default"] = _default;